/**
 * COMMAND_ATTRIBUTES — maps command types to their dynamic attribute fields.
 * Shared between CommandsSettings (saved command CRUD) and SendCommandDialog (ad-hoc send).
 */
export const COMMAND_ATTRIBUTES = {
  custom:           [{ key: 'data', type: 'string', label: 'commandData' }],
  positionPeriodic: [{ key: 'frequency', type: 'number', label: 'commandFrequency' }],
  setTimezone:      [{ key: 'timezone', type: 'string', label: 'commandTimezone' }],
  sendSms:          [{ key: 'phone', type: 'string', label: 'commandPhone' },
                     { key: 'message', type: 'string', label: 'commandMessage' }],
  message:          [{ key: 'message', type: 'string', label: 'commandMessage' }],
  sendUssd:         [{ key: 'phone', type: 'string', label: 'commandPhone' }],
  sosNumber:        [{ key: 'index', type: 'number', label: 'commandIndex' },
                     { key: 'phone', type: 'string', label: 'commandPhone' }],
  outputControl:    [{ key: 'index', type: 'number', label: 'commandIndex' },
                     { key: 'data', type: 'string', label: 'commandData' }],
  setConnection:    [{ key: 'server', type: 'string', label: 'commandServer' },
                     { key: 'port', type: 'number', label: 'commandPort' }],
  setOdometer:      [{ key: 'data', type: 'string', label: 'commandData' }],
  voiceMonitoring:  [{ key: 'enable', type: 'boolean', label: 'commandEnable' }],
  alarmBattery:     [{ key: 'enable', type: 'boolean', label: 'commandEnable' }],
  alarmSos:         [{ key: 'enable', type: 'boolean', label: 'commandEnable' }],
  alarmRemove:      [{ key: 'enable', type: 'boolean', label: 'commandEnable' }],
  alarmFall:        [{ key: 'enable', type: 'boolean', label: 'commandEnable' }],
  modePowerSaving:  [{ key: 'enable', type: 'boolean', label: 'commandEnable' }],
  modeDeepSleep:    [{ key: 'enable', type: 'boolean', label: 'commandEnable' }],
  setAgps:          [{ key: 'enable', type: 'boolean', label: 'commandEnable' }],
  alarmGeofence:    [{ key: 'radius', type: 'number', label: 'commandRadius' }],
  silenceTime:      [{ key: 'data', type: 'string', label: 'commandData' }],
  setPhonebook:     [{ key: 'data', type: 'string', label: 'commandData' }],
  voiceMessage:     [{ key: 'data', type: 'string', label: 'commandData' }],
  setIndicator:     [{ key: 'data', type: 'string', label: 'commandData' }],
  configuration:    [{ key: 'data', type: 'string', label: 'commandData' }],
  alarmClock:       [{ key: 'data', type: 'string', label: 'commandData' }],
  alarmSpeed:       [{ key: 'data', type: 'string', label: 'commandData' }],
  alarmVibration:   [{ key: 'data', type: 'string', label: 'commandData' }],
  positionSingle:    [],
  positionStop:      [],
  engineStop:        [],
  engineResume:      [],
  alarmArm:          [],
  alarmDisarm:       [],
  alarmDismiss:      [],
  deviceIdentification: [],
  requestPhoto:      [],
};

/** Convert camelCase to readable label as fallback */
export function camelToReadable(str) {
  return str.replace(/([A-Z])/g, ' $1').replace(/^./, (s) => s.toUpperCase()).trim();
}
